import { useCreateCardBackground, useRemoveCardBackground } from '@/generated/hooks';

/** Upload/replace and remove commands for one card's background image. */
export function useCardBackground(merchantId: number, cardId: string) {
  const upload = useCreateCardBackground();
  const remove = useRemoveCardBackground();
  return {
    isBusy: upload.isPending || remove.isPending,
    upload: (data: {
      content_type: 'image/jpeg' | 'image/png' | 'image/webp';
      image_base64: string;
      expected_revision: number;
    }) => upload.mutateAsync({ merchantId, cardId, data }),
    remove: (expectedRevision: number) =>
      remove.mutateAsync({ merchantId, cardId, data: { expected_revision: expectedRevision } }),
  };
}
